import { ReactNode } from 'react';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import { Button } from '@nf/ui';
import { CloseLineIcon, ArrowLeftIcon } from '@/components/icons/svg-icons';
import { ReactPortal } from '@/components/widgets/react-portal';
import { modalStyle } from './modal.style';
import clsx from 'clsx';

const modalVariants = cva('modal', {
	variants: {
		variant: {
			center: 'modal--center',
			top: 'modal--top',
			full: modalStyle.full,
			event: 'modal--event',
			virtualWidget: 'modal--center modal--virtua-euro',
			transparent: 'modal--transparent',
		},
	},
	defaultVariants: {
		variant: 'top'
	}
});

interface ModalProps
	extends VariantProps<typeof modalVariants> {
		isOpen: boolean;
		closeModal: () => void;
		children: ReactNode;
		className?: string;
		showHeader?: boolean;
		title?: string;
		isBackdropClose?: boolean;
        isShowClose?: boolean;
	}
;

export const Modal = ({
	variant,
	isOpen,
	closeModal,
	children,
	className,
	showHeader = true,
	title = '',
	isBackdropClose = true,
	isShowClose = true,
}: ModalProps) => {
	const handleBackgropClose = () => {
		isBackdropClose ? closeModal() : null
	}
	return isOpen ? (
		<ReactPortal wrapperId="modal-portal">
			<section className={clsx(modalVariants({ variant, className }), modalStyle.marsModal)}>
				<div className="modal__overlay" onClick={handleBackgropClose}></div>
				<div className="modal__container">
					{showHeader ? (
						<div className="modal__header">
							{ variant === 'full' ? (
								<Button variant="icon" onClick={closeModal} className={modalStyle.backButton}>
									<ArrowLeftIcon />
								</Button>
							) : null}
							{title.length > 0 && (
								<div className="modal__title">
									{title}
								</div>
							)}
							{ isShowClose ? (
								<div className="modal__close-btn">
									<Button variant="icon" onClick={closeModal}>
										<CloseLineIcon />
									</Button>
								</div>
							) : null}
						</div>
					) : null}
					<div className="modal__body">
						{children}
					</div>
				</div>
			</section>
		</ReactPortal>
	): null;
};
